import React, { useCallback, useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";

import { showToast } from "../ToastManager";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from "primereact/dialog";

import PrestadorService from '../../service/PrestadorService';
import AuthorizationService from '../../service/AuthorizationService';

const prestadorService = new PrestadorService();

const ListarPrestadores = () => {
    const [prestador, setPrestador] = useState([]);
    const [filters1, setFilters1] = useState(null);
    const [loading1, setLoading1] = useState(false);
    const history = useHistory();
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [activeDialog, setActiveDialog] = useState(false);
    const [toDelete, setToDelete] = useState(null);
    const [toActive, setToActive] = useState(null);

    const iss = localStorage.getItem('iss');

    const initFilters1 = useCallback(() => {
        setFilters1({
            'nome': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
            'email': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
            /* 'login.email': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] }, */
        });
    }, []);

    const initPrestador = useCallback(async () => {
        setLoading1(true);

        try {
            const data = await prestadorService.listPrestadores(iss);
            setPrestador(data.data.rows);
        } catch (error) {
            console.error("Erro ao carregar profissionais:", error);
            showToast({ severity: 'error', summary: 'Erro', detail: 'Erro ao carregar profissionais' });
        } finally {
            setLoading1(false);
        }
    }, [iss]);

    useEffect(() => {
        initFilters1();
        initPrestador();
    }, [initFilters1, initPrestador]);

    const irParaCadastro = () => {
        if (AuthorizationService.hasPermission('postPrestador'))
            history.push('/prestador/cadastrar');
    }

    const abreModalDeletar = (toDelete) => {
        setToDelete(toDelete);
        setDeleteDialog(true);
    }

    const abreModalAtivar = (prestador) => {
        setToActive(prestador);
        setActiveDialog(true);
    }

    const handleDeletePrestador = () => {
        if (AuthorizationService.hasPermission('deletePrestador')) {
            setLoading1(true)
            prestadorService.deletePrestador(iss, toDelete.id).then(() => {
                showToast({ severity: 'success', summary: 'Sucesso', detail: 'Profissional excluído com sucesso' });
                setLoading1(false);
                hideModalDeletar();
                initPrestador();
            });
        }
    }

    const handleActiveUsuario = () => {
        if (AuthorizationService.hasPermission('activePrestador')) {
            setLoading1(true)
            let status = toActive.ativo ? 0 : 1;
            prestadorService.activePrestador(iss, toActive.id, status).then((data) => {
                showToast({ severity: 'success', summary: 'Sucesso', detail: `Profissional ${status ? 'ativado' : 'desativado'} com sucesso` });
                setLoading1(false);
                hideModalActive();
                initPrestador();
            }, error => {
                showToast({ severity: 'error', summary: 'Erro', detail: 'Erro ao ativar/destivar empresa' });
            }).finally(() => { setLoading1(false) });

        }
    }

    const editar = (prestadorParaEditar) => {
        if (AuthorizationService.hasPermission('getPrestador'))
            history.push('/prestador/editar/' + prestadorParaEditar.id);
    }

    const hideModalDeletar = () => {
        setDeleteDialog(false);
        setToDelete(null);
    }

    const hideModalActive = () => {
        setActiveDialog(false);
        setToActive(null);
    }

    const statusBody = (rowData) => {
        return AuthorizationService.hasPermission('activeUser') ? <Button icon={rowData.ativo ? 'pi pi-check' : 'pi pi-times'} onClick={() => { abreModalAtivar(rowData) }} className="p-button-rounded  mr-2 mb-2" style={{ backgroundColor: rowData.ativo ? 'green' : 'red', color: 'black' }} /> : <></>
    }

    const opcoesBody = (rowData) => {
        return <span style={{ display: 'flex', justifyContent: 'space-between' }}>
            {AuthorizationService.hasPermission('deletePrestador') ? <Button icon="pi pi-trash" onClick={() => { abreModalDeletar(rowData) }} style={{ backgroundColor: 'red', borderColor: 'red' }} className="p-button-rounded mr-2 mb-2" /> : <></>}
            {AuthorizationService.hasPermission('getPrestador') ? <Button icon="pi pi-pencil" onClick={() => { editar(rowData) }} className="p-button-rounded  mr-2 mb-2" /> : <></>}
        </span>
    }

    const deleteDialogFooter = (
        <>
            <Button loading={loading1} label="Não" icon="pi pi-times" className="p-button-text" onClick={hideModalDeletar} />
            <Button loading={loading1} label="Sim" icon="pi pi-check" className="p-button-text" onClick={handleDeletePrestador} />
        </>
    );

    const activeDialogFooter = (
        <>
            <Button loading={loading1} label="Não" icon="pi pi-times" className="p-button-text" onClick={hideModalActive} />
            <Button loading={loading1} label="Sim" icon="pi pi-check" className="p-button-text" onClick={handleActiveUsuario} />
        </>
    );

    return (
        <div className="grid table-demo">
            <div className="col-12">
                {AuthorizationService.hasPermission('postPrestador') ? <Button label="Cadastrar" onClick={irParaCadastro} className="mr-2 mb-2"></Button> : <></>}
                <div className="card">
                    <h5>Profissionais</h5>
                    <DataTable value={prestador} paginator className="p-datatable-gridlines" showGridlines rows={10}
                        dataKey="id" filters={filters1} filterDisplay="menu" loading={loading1} responsiveLayout="scroll"
                        emptyMessage="Nenhuma prestador cadastrado.">
                        <Column sortable field="nome" header="Nome" filter filterPlaceholder="Procurar por nome" style={{ minWidth: '12rem' }} />
                        <Column sortable field="cpf" header="CPF" filter filterPlaceholder="Procurar por cpf" style={{ minWidth: '12rem' }} />
                        <Column sortable field="telefone" header="Telefone" filter filterPlaceholder="Procurar por telefone" style={{ minWidth: '12rem' }} />
                        <Column sortable field="email" header="E-mail" filter filterPlaceholder="Procurar por e-mail" style={{ minWidth: '12rem' }} />
                        <Column sortable field="status" body={statusBody} header="Ativo" style={{ width: '1rem' }} />
                        <Column header="Opções" body={opcoesBody} style={{ width: '8rem' }} />
                    </DataTable>
                </div>
            </div>

            <Dialog visible={deleteDialog} style={{ width: '450px' }} header="Deletar" modal footer={deleteDialogFooter} onHide={hideModalDeletar}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    <span>Tem certeza que deseja excluir o profissional selecionado?</span>
                </div>
            </Dialog>

            <Dialog visible={activeDialog} style={{ width: '450px' }} header="Ativar/Desativar" modal footer={activeDialogFooter} onHide={hideModalActive}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    <span>Tem certeza que deseja ativar/destivar o profissional selecionado?</span>
                </div>
            </Dialog>
        </div>

    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(ListarPrestadores, comparisonFn);
